import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { ComissoesContent } from '@/features/comissoes/comissoes-content';
import { DashboardComissoesComponent } from '@/features/comissoes/dashboard-comissoes/dashboard-comissoes';
import { comissoesRelatoriosRoutes } from '@/features/comissoes/relatorios/comissoes-relatorios.routes';
import { GerenciarComissoesComponent } from '@/features/comissoes/gerenciar-comissoes/gerenciar-comissoes';
import { PainelComissoesComponent } from '@/features/comissoes/painel-comissoes/painel-comissoes';
import { COMISSOES_ROUTES } from '@/features/comissoes/comissoes.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

const breadcrumbTipoComissao = (route: ActivatedRouteSnapshot): string => (route.paramMap.get('tipo') === COMISSOES_ROUTES.TIPO.ATIVIDADES ? 'Atividades' : 'Acompanhamento');

/**
 * O fragmento da URL só existe quando a navegação parte de dentro da aplicação. Em acesso
 * direto ou recarga ele vem nulo e o breadcrumb caía no segmento cru da rota ("item/3437"),
 * por isso o código vira rótulo legível.
 */
const breadcrumbItem =
    (prefixo: string) =>
    (route: ActivatedRouteSnapshot): string => {
        const codigo = route.paramMap.get('codigo');
        return route.fragment || (codigo ? `${prefixo} ${codigo}` : prefixo);
    };

export const comissoesRoutes: Routes = [
    {
        path: COMISSOES_ROUTES.ROOT,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Comissões', permission: PERMISSOES.comissoes.modulo },
        children: [
            { path: '', pathMatch: 'full', redirectTo: COMISSOES_ROUTES.DASHBOARD },
            {
                path: COMISSOES_ROUTES.DASHBOARD,
                component: ComissoesContent,
                data: { breadcrumb: 'Dashboard' },
                children: [{ path: '', component: PainelComissoesComponent }]
            },
            ...comissoesRelatoriosRoutes,
            {
                path: ':tipo',
                component: ComissoesContent,
                resolve: { breadcrumb: breadcrumbTipoComissao },
                data: { breadcrumb: null },
                children: [
                    { path: '', component: DashboardComissoesComponent },
                    { path: COMISSOES_ROUTES.DASHBOARD, component: DashboardComissoesComponent, data: { breadcrumb: 'Dashboard' } },
                    {
                        path: COMISSOES_ROUTES.COMISSOES,
                        canActivate: [permissionGuard],
                        data: { breadcrumb: 'Comissões', permission: PERMISSOES.comissoes.cadastro.escopo },
                        children: [
                            { path: '', component: GerenciarComissoesComponent },
                            {
                                path: `${COMISSOES_ROUTES.ITEM}/:codigo`,
                                component: GerenciarComissoesComponent,
                                resolve: { breadcrumb: breadcrumbItem('Comissão') },
                                data: { breadcrumb: null }
                            }
                        ]
                    },
                    {
                        path: `${COMISSOES_ROUTES.ITEM}/:codigo`,
                        component: DashboardComissoesComponent,
                        resolve: { breadcrumb: breadcrumbItem('Reunião') },
                        data: { breadcrumb: null }
                    }
                ]
            }
        ]
    }
];

export default comissoesRoutes;
